module.exports = __webpack_public_path__ + "static/img/hr.a7f61bab.svg";